import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { config } from "../../../../environments/config";
import { EstadoCuenta, SocioCredito, SocioTablaCredito, Solicitudcredito, SolCredito } from "../../_model";
import { BehaviorSubject, Observable, Subject, throwError, ReplaySubject } from "rxjs";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { UsuarioService } from '../usuario/usuario.service';
import { SocioCuentasInterface } from 'app/main/_model/socios/socio.interface';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SgfCreditoService {

    public header: any;

    private creditos$: BehaviorSubject<SocioCuentasInterface> = new BehaviorSubject(null);
    private maximoTransferir$: BehaviorSubject<any> = new BehaviorSubject(null);
    private solicitudcredito$ = new ReplaySubject<any>()
    constructor(private http: HttpClient,
        private userSrv: UsuarioService,) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    public tipoCredito() {
        return this.http.get(`${config.apiUrl}/tipocredito/filter`)
            .toPromise()
            .then(res => <[]>res)
            .then(data => {
                return data;
            });
    }
    public getTipoCreditos(): Observable<any> {
        return this.http.get(`${config.apiUrl}/tipocredito/filter`)
            .pipe(map((res: any) => {
                const data = [];
                res.data.forEach(element => {
                    this.verificaTipoCredito(element.codTipoCredito)
                        .toPromise().then(res => {
                            // console.log(res);
                            if (res) {
                                data.push(element);
                            }
                        });

                });
                return data;
            }), catchError((err) => this.error(err)));
    }

    public verificaTipoCredito(codTipoCredito: any): Observable<boolean> {

        return this.getClasificacionCredito(codTipoCredito)
            .pipe(map(res => {
                let estado = false;
                if (res.length != 0) {
                    // console.log('estado -> true codigo '+codTipoCredito)
                    estado = true;
                }
                return estado
            }), catchError((err) => this.error(err)));
    }


    public getClasificacionCredito(idTipoCredito: any): Observable<any> {
        return this.http.get(`${config.apiUrl}/credito/clasificacion`)
            .pipe(map((res: any) => {
                const data = [];
                res.data.forEach(element => {
                    if (element.codTipoCredito == idTipoCredito) {
                        data.push(element);
                    }
                });
                return data;
            }), catchError((err) => this.error(err)));
    }


    filterCreditos(token, producto) {
        const params = new HttpParams()
            .set('token', token);
        return this.http.post<any>(`${config.apiUrl}/socio/creditos`, params)
            .toPromise()
            .then(res => <SocioCredito[]>res.data)
            .then(data => {
                return data;
            });
    }

    CreditoTabla(token, producto, cuenta) {
        const params = new HttpParams()
            .set('token', token)
            .set('producto', producto)
            .set('cuenta', cuenta);
        return this.http.post<any>(`${config.apiUrl}/socio/creditos/detalle`, params)
            .toPromise()
            .then(res => <SocioTablaCredito[]>res.data)
            .then(data => {
                return data;
            });
    }

    public getCreditoColoc() {
        return this.http.get<any>(`${config.apiUrl}/credito/colocacion/filter`)
            .toPromise()
            .then(res => <[]>res.data)
            .then(data => {
                return data;
            });
    }

    public getSubClaseTipoCredito(idTipoCredito: any): Observable<any> {
        const params = new HttpParams().set('id', idTipoCredito);
        return this.http.post(`${config.apiUrl}/credito/clasificacion/filter`, params, { headers: this.header })
            .pipe(map((res: any) => {
                return res.data;
            }), catchError((err) => this.error(err)));
    }

    private error(error): Observable<never> {
        let errorMessage;
        if (error) {
            errorMessage = `Error: code ${error.message}`
        }
        return throwError(errorMessage);
    }

    filterSolicitudes(token) {
        const params = new HttpParams()
            .set('token', token);
        return this.http.post<any>(`${config.apiUrl}/creditos/solicitud`, params)
            .toPromise()
            .then(res => <SolCredito[]>res.data)
            .then(data => {
                return data;
            });
    }

    crearSolicitudCredito(user: Solicitudcredito): Observable<any>{
        const body = new HttpParams()
            .set('token', user.token)
            .set('cuenta', user.cta)
            .set('tasa', user.valTasaMax)
            .set('valinteres', user.totalInteres)
            .set('capital', user.totalCapital)
            .set('cuotas', user.numCuotas)
            .set('fechaprestamo', user.fsolicitud)
            .set('fechavencimiento', user.fvencimiento)
            .set('tipocredito', user.tipocredito)
            // .set('clasifcredito', '8')
            .set('clasifcredito', user.clasifcredito)
            .set('plazo', user.plazoDias)
            .set('fecvencimiento', user.fecVencimineto)
            .set('archivo', user.archivo)
            .set('txtCanton', user.txtCanton);
        return this.http.post(`${config.apiUrl}/creditos/solicitud/create`, body)
            // .toPromise()
            // .then(res => <SolCredito>res)
            // .then(data => {
            //     return data;
            // });
            .pipe(map((res: any) => {
                return res;
            }), catchError((err) => this.error(err)));
    }

    crearSocilitudCreditoTabla(token, tabla: any[]): Observable<any>{
        const params = new HttpParams()
        .set('token', token)
    return this.http.post(`${config.apiUrl}/creditos/solicitud/tabla/create`, tabla, {params} )
        .pipe(map((res: any) => {
            return res;
        }), catchError((err) => this.error(err)));
    }

    // crearSocilitudCreditoTabla(token, numcuota, valcapital, valinteres, tasa, fechaini, fechafin) {
    //     const body = new HttpParams()
    //         .set('token', token)
    //         .set('numcuota', numcuota)
    //         .set('valcapital', valcapital)
    //         .set('valinteres', valinteres)
    //         .set('tasa', tasa)
    //         .set('fechaini', fechaini)
    //         .set('fechafin', fechafin);
    //     return this.http.post<any>(`${config.apiUrl}/creditos/solicitud/amortizacion`, body)
    //         .toPromise()
    //         // .then(res => <Sgfsolicitudtabla[]>res)
    //         .then(data => {
    //             return data; 
    //         });
    // }

    descargarSolicitud(token, cuenta) {
        const body = new HttpParams()
            .set('token', token)
            .set('cuenta', cuenta);
        return this.http.post<any>(`${config.apiUrl}/creditos/solicitud/pdf`, body, {responseType: 'blob' as 'json'})
            .toPromise()
            .then(blob => {
                return blob;
            });
    }
}

@Injectable({
    providedIn: 'root'
})
export class SgfCreditoSolicitudService {
    private solicitudcredito$ = new ReplaySubject<any>()
    constructor(private http: HttpClient,
        private userSrv: UsuarioService,) {
    }

    /*
   transferencia interna
    */
    public recibeSolicitud(event: any) {
        console.log(event);
        this.solicitudcredito$.next(event);
    }

    public get enviaSolicitud() {
        return this.solicitudcredito$.asObservable()
    }
}
